import * as moment from 'moment';
import {INewsService, INewsItem} from './news.types';

export default class NewsService implements INewsService {
  static $inject = ['$q'];

  constructor(private $q:ng.IQService) {

  }

  getLatestNews():ng.IPromise<INewsItem[]> {
    return this.$q.when([{
        title: 'Hydromet 2.1.1 released',
        date: moment({y: 2021, M: 9, d: 1}),
        content: ''
    }]);
  }
}



/** WEBPACK FOOTER **
 ** ./app/news/news.service.ts
 **/